import { Component, Input, OnInit } from '@angular/core';
import { LocalesService, ConfigService } from './locales.service';
import { Observable } from 'rxjs';
import { Locale } from './Locale';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-locale',
  template: `
    <span *ngIf="(observableLocale | async)?.contentType === 'text/plain'"
      [attr.title]="showTitle ? (observableLocale | async)?.value : null">
      {{(observableLocale | async)?.value}}
    </span>
    <span *ngIf="(observableLocale | async)?.contentType === 'text/html'" 
      [attr.title]="showTitle ? (observableLocale | async)?.value : null">
      <span [innerHtml] = '(observableLocale | async)?.value'></span>
    </span>`,
})
export class LocaleComponent implements OnInit {
  @Input() localeKey: string;
  @Input() localeView: string = null;
  @Input() showTitle: boolean = false;

  observableLocale: Observable<Locale>;

  constructor(private localeService: LocalesService, private configService: ConfigService) { }

  ngOnInit() {
    this.setLocale();
  }

  getLocaleString() {
    return this.localeService.getLocalesByLang(this.configService.languagerequested)
      .pipe(
        map((locales: Locale[]) => {
          let filteredLocales = locales.filter((item) => {
            return item.key === this.localeKey && (item.view == null || item.view == undefined || item.view === this.localeView);
          });
  
          if (filteredLocales.length > 0) {
            return filteredLocales[0]
          } else {
            return {} as Locale;
          }
        })
      );
  }

  setLocale() {
    this.observableLocale = this.getLocaleString();
  }
}
